<template>
    <span class="urge-info-count">
        <span>优惠名额仅剩</span><span class="urge-info-number">{{remainingCount}}</span><span>人</span>
    </span>
</template>
<script>
export default {
    props: {
        // 剩余个数
        remainingCount: {
            type: Number,
            default() {
                return 0;
            }
        }
    }
};
</script>
<style lang="less">
.urge-info-count {
    .urge-info-number {
        font-variant-numeric: tabular-nums;
        font-family: arial, Helvetica, sans-serif;
    }
}
</style>
